import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { getIsDialogOpen } from '../../state/redux/features/ui/selectors';

import { isStoreSelectorFeatureEnabled } from '../../feature-flags/feature-flags';

const LazyStoreSelectorShopModal = React.lazy(
  () =>
    /* webpackChunkName: StoreSelectorShopModal */ import(
      '../../experiments/mybag-3716-store_selector_mfe/components/shop-modal/ConnectedShopModal'
    ),
);

const LazyShopModal = React.lazy(
  () => /* webpackChunkName: LazyShopModal */ import('./ConnectedShopModal'),
);

const ShopModalWrapper = () => {
  const isModalOpen = useSelector(getIsDialogOpen);

  return isModalOpen ? (
    <Suspense fallback={null}>
      {isStoreSelectorFeatureEnabled ? <LazyStoreSelectorShopModal /> : <LazyShopModal />}
    </Suspense>
  ) : null;
};

export default ShopModalWrapper;
